var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMessages(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_1880",
    "data-name": "Groupe 1880",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1764",
    "data-name": "Rectangle 1764",
    width: 48,
    height: 48,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_1881",
    "data-name": "Groupe 1881",
    transform: "translate(4.479 4.479)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Item_4",
    "data-name": "Item 4",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Comments",
    d: "M8.133,39.043a1.629,1.629,0,0,1-1.3-.684A1.722,1.722,0,0,1,6.591,36.8l1.865-5.838C3.161,27.8,0,22.569,0,16.972A15.821,15.821,0,0,1,5.742,4.94,21,21,0,0,1,19.521,0,21,21,0,0,1,33.3,4.94a15.821,15.821,0,0,1,5.742,12.033A15.822,15.822,0,0,1,33.3,29.006a21,21,0,0,1-13.779,4.94c-.744,0-1.494-.037-2.231-.11L8.941,38.813A1.561,1.561,0,0,1,8.133,39.043Zm17.9-23.767a1.7,1.7,0,1,0,1.627,1.7A1.664,1.664,0,0,0,26.028,15.276Zm-6.507,0a1.7,1.7,0,1,0,1.627,1.7A1.664,1.664,0,0,0,19.521,15.276Zm-6.507,0a1.7,1.7,0,1,0,1.627,1.7A1.664,1.664,0,0,0,13.014,15.276Z",
    transform: "translate(0 0)",
    fill: "#e30613"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessages);
export default __webpack_public_path__ + "static/media/messages.b5f8f01c273ed695dc9e0cf746046671.svg";
export { ForwardRef as ReactComponent };